// frontend/src/components/Schedules/ScheduleHome.js
import React from 'react';
import { Link } from 'react-router-dom';

function ScheduleHome() {
    return (
        <div className="container">
            <h1>Schedule Management</h1>
            <p>Manage class schedules, section periods, and scheduling tools for your academic programs.</p>
            
            <div className="schedule-actions">
                <h2>Schedule Tools</h2>
                <div className="action-grid">
                    <Link to="/schedules/create-section" className="action-card">
                        <h3>⏰ Manage Section Periods</h3>
                        <p>Create and configure class periods and time blocks</p>
                    </Link>
                    
                    <Link to="/schedules/block-schedules" className="action-card">
                        <h3>📋 View Block Schedules</h3>
                        <p>Review and monitor existing block schedules</p>
                    </Link>
                    
                    <Link to="/schedules/tool" className="action-card">
                        <h3>🛠️ Open Scheduling Tool</h3>
                        <p>Interactive tool for creating and managing schedules</p>
                    </Link>
                    
                    <Link to="/schedules/teacher-schedule" className="action-card">
                        <h3>👨‍🏫 Teacher Daily Schedule</h3>
                        <p>View daily scheduled section periods by teacher</p>
                    </Link>
                </div>
            </div>
            
            <style jsx>{`
                .container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 20px;
                }
                
                .action-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 20px;
                    margin-top: 20px;
                }
                
                .action-card {
                    display: block;
                    padding: 24px;
                    border: 1px solid #e0e0e0;
                    border-radius: 12px;
                    text-decoration: none;
                    color: inherit;
                    transition: all 0.3s ease;
                    background: #ffffff;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                }
                
                .action-card:hover {
                    border-color: #1976d2;
                    box-shadow: 0 4px 12px rgba(25,118,210,0.15);
                    transform: translateY(-3px);
                }
                
                .action-card h3 {
                    margin: 0 0 12px 0;
                    color: #1976d2;
                    font-size: 1.2rem;
                    font-weight: 600;
                }
                
                .action-card p {
                    margin: 0;
                    color: #666;
                    line-height: 1.5;
                }
                
                .schedule-actions h2 {
                    color: #333;
                    margin-bottom: 10px;
                    font-size: 1.5rem;
                }
                
                h1 {
                    color: #1976d2;
                    margin-bottom: 10px;
                }
                
                p {
                    color: #666;
                    margin-bottom: 30px;
                    font-size: 1.1rem;
                }
            `}</style>
        </div>
    );
}

export default ScheduleHome;
